module.exports = __webpack_public_path__ + "static/media/EW2A1883.4c8f6d62.jpg";